import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import useScroll from "../hooks/useScroll";
// import { Header, Caption } from "../components";
import { GotoTop } from "../components/Common/GotoTop";
import { ThemeType } from "../styles/theme";
import { guideData } from "../constants/GuideData";
import { GuideData } from "../types";
import Divider from "../assets/guide/divider@2x.png";

import { withVersionParams } from "../HOC/withVersionParams";
import Header from "../components/GuidePage/Header";
import Caption from "../components/GuidePage/Caption";

type ParamTypes = {
   [guideId: string]: string | undefined;
};

interface StyleProps {
   item: GuideData;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
      margin: "0 auto",
   },
   top: {
      position: "relative",
      height: 420,
      color: theme.mono100,
      background: ({ item }: StyleProps) =>
         `url(${item.img}) bottom center no-repeat`,
      backgroundSize: "100% auto!important",
      "@media (max-width: 375px)": {
         backgroundSize: "375px auto!important",
      },
   },
   desc: {
      padding: `30px 0px 60px`,
      "& div.background__gray": {
         backgroundColor: "rgb(249, 249, 249)",
         paddingTop: 60,
         paddingBottom: 60,
         "& > h2": {
            margin: 0,
         },
      },
      "& div.padding": {
         padding: "20px 20px",
      },
      "& div.alert": {
         position: "relative",
         "& h2.nMT": {
            marginTop: 0,
         },
         "& div.alert__text": {
            ...theme.sText,
            boxSizing: "border-box",
            marginRight: 20,
            // padding: "2px 8px 4px",
            textAlign: "center",
            width: "108px",
            height: "28px",
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: theme.aquaMarine,
            borderRadius: 14,
            color: theme.mono100,
         },
      },
      "& div.mgt__60": {
         marginTop: 60,
      },
      "& div.pdt__40": {
         paddingTop: 40,
      },
      "& div.mgt__10": {
         marginTop: 10,
      },
      "& div.pd-30": {
         padding: "30px",
      },
      "& > h2:first-child": {
         padding: `0px ${theme.gap}px`,
         marginTop: 0,
      },
      "& h2": {
         padding: `0px ${theme.gap}px`,
         fontSize: "2.2rem",
         marginTop: 60,
         fontWeight: theme.demiLight,
         lineHeight: "3.2rem",
         "&.noMT": {
            marginTop: 22,
         },
         "&.MT-50": {
            marginTop: 50,
         },
         "&.MT-140": {
            marginTop: 140,
         },
         "&.MT-60": {
            marginTop: 60,
         },
         // "&.alert": {
         //   background: `url${} right 0px center no-repeat`,
         //   backgroundSize: "108px 28px"
         // }
      },
      "& h2 + p": {
         marginTop: 10,
         "&.pad": {
            marginTop: 20,
         },
      },
      "& > p:first-child": {
         marginTop: 0,
      },
      "& b": {
         fontWeight: theme.medium,
      },
      "& ul": {
         margin: 0,
         paddingLeft: 13,
         "&.big": {
            marginTop: 26,
            "& > li": {
               lineHeight: "3.2rem",
               fontSize: "1.8rem",
            },
         },
      },
      "& ul > li": {
         padding: `0px 0px 10px`,
         fontSize: "1.6rem",
         color: theme.mono50,
         lineHeight: "2.6rem",
         listStyleType: "none",
         position: "relative",
         "&:last-of-type": {
            padding: 0,
         },
         "&::before": {
            content: '"·"',
            position: "absolute",
            left: "-1.3rem",
         },
      },
      "& ul.line-break": {
         "& > li": {
            "&.pdb-20": {
               paddingBottom: 20,
            },
            "& > span": {
               ...theme.t3,
               lineHeight: "3.2rem",
               letterSpacing: "-0.022rem",
               "&:first-of-type": {
                  ...theme.t3,
                  letterSpacing: "-0.022rem",
                  lineHeight: "3.2rem",
                  fontWeight: theme.medium,
                  color: theme.mono0,
               },
               "&:last-of-type": {
                  margin: 0,
               },
            },
         },
      },
      "& ul + span": {
         marginTop: "26px!important",
      },
      "& p": {
         padding: `0px ${theme.gap}px`,
         fontSize: "1.8rem",
         color: theme.mono50,
         marginTop: 20,
         lineHeight: "3.2rem",
         "& span": {
            display: "block",
            marginTop: 30,
            "&:first-of-type": {
               marginTop: 0,
            },
            "&.list-item": {
               lineHeight: "2.6rem",
            },
            "&.list-desc": {
               marginTop: 1,
               marginLeft: 14,
               lineHeight: "3.2rem",
            },
            "&.small": {
               fontSize: "1.6rem",
               marginLeft: 18,
            },
            "&.ls-22": {
               letterSpacing: "-0.022rem",
            },
         },
         "&.pad": {
            marginTop: 60,
         },
         "&.hash-tag": {
            marginTop: 60,
         },
         "&.medium": {
            fontWeight: theme.medium,
         },
         "& > div.example": {
            marginTop: 20,
            padding: "1.8rem 1.6rem",
            border: `1px solid ${theme.monoDivider}`,
            "& > span": {
               fontWeight: theme.medium,
            },
            "& div": {
               marginTop: 10,
            },
            "& ul": {
               margin: 0,
               paddingLeft: 13,
               "&.big": {
                  marginTop: 10,
                  "& > li": {
                     lineHeight: "3.2rem",
                     fontSize: "1.8rem",
                  },
               },
            },
         },
      },
      "& img": {
         padding: `0px ${theme.gap}px`,
         width: "100%",
         marginTop: 20,
         "&.banner": {
            padding: 0,
            marginTop: 0,
            marginBottom: -60,
         },
         "&.full": {
            padding: 0,
         },
         "&.thumb-nail": {
            width: 117,
            height: 117,
         },
      },
      // "& video": {
      //   display: "block",
      //   width: "100%",
      //   padding: `20px ${theme.gap}px 0px`,
      // },
      "&  div.center": {
         display: "flex",
         justifyContent: "center",
         alignItems: "center",
         marginTop: 60,
         "& > img": {
            width: 117,
            height: "auto",
            padding: 0,
            margin: 0,
         },
      },
      "& > div.video-container": {
         width: `calc(100% - ${theme.gap * 2}px)`,
         margin: "20px auto 0px",
         position: "relative",
         padding: `20px 0px 55.95%`,
         marginBottom: -40,
         height: 0,
         overflow: "hidden",
         "& iframe, & object, & embed": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "calc(100% - 40px)",
         },
      },
      "& div.slider": {
         "& ~ h2": {
            marginTop: 86,
         },
      },
      "& div.divider": {
         padding: `0px ${theme.gap}px`,
         width: "100%",
         background: `url(${Divider}) center center no-repeat`,
         backgroundSize: "143px 20px",
         height: 20,
         marginTop: 60,
      },
      "& > div.gray": {
         background: theme.monoBg,
         padding: 20,
         "& > h2": {
            "&.mgN": {
               marginTop: 0,
            },
         },
      },
      "&.footer": {
         padding: 0,
      },

      "& .height-40": {
         height: 40,
      },
      "& .padding-0": {
         padding: 0,
      },
      "& .word-spacing": {
         paddingLeft: 19,
      },
      "& .white-button": {
         display: "block",
         margin: "20px 0px 50px",
         width: "100%",
         borderRadius: 6,
         border: `1px solid ${theme.primarySol}`,
         padding: `13px ${theme.gap}px`,
         color: theme.primaryTxt,
         fontFamily: `${theme.font}`,
         fontSize: "1.8rem",
         lineHeight: "2.8rem",
         "&:disabled": {
            border: `1px solid ${theme.monoDivider}`,
            color: theme.monoDim,
         },
      },
      "& .blue-button": {
         display: "block",
         margin: "20px 0px",
         width: "100%",
         borderRadius: 6,
         backgroundColor: `${theme.primarySol}`,
         padding: `13px ${theme.gap}px`,
         color: theme.mono100,
         fontFamily: `${theme.font}`,
         fontSize: "1.8rem",
         lineHeight: "2.8rem",
         "&:disabled": {
            border: `1px solid ${theme.monoDivider}`,
            color: theme.monoDim,
         },
      },
   },
}));

const GuideDetailPage: React.FC = () => {
   const { guideId } = useParams<ParamTypes>();

   const item = guideData[Number(guideId)];
   const classes = useStyles({ item });
   const isEventPage = Number(guideId) === 4;
   let timerId: any = null;

   const bottomButtonSize = isEventPage ? 74 : 0;

   const { scrollY } = useScroll();

   const [isShown, setShown] = useState<boolean>(false);
   const [isScrolling, setIsScrolling] = useState<boolean>(false);
   const [endScroll, setEndScroll] = useState<boolean>(false);

   useEffect(() => {
      if (scrollY > 356 && document.body.getBoundingClientRect().top < 0) {
         setShown(true);
         setEndScroll(
            window.pageYOffset + window.innerHeight >=
               document.body.scrollHeight
         );
      } else {
         setShown(false);
      }
   }, [scrollY]);

   const onScroll = () => {
      if (window.pageYOffset === 0) {
         setIsScrolling(false);
         return;
      }

      setIsScrolling(true);

      if (timerId !== null) {
         clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
         setIsScrolling(false);
      }, 2000);
   };

   const goToTop = () => {
      window.scrollTo(0, 0);
   };

   useEffect(() => {
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
   }, []);

   return (
      <>
         <div className={classes.wrap}>
            <HelmetProvider>
               <Helmet>
                  <title>{item.title}</title>
               </Helmet>
            </HelmetProvider>
            <Header
               isShown={isShown}
               title={item.title}
               reverseColor={item.reverseColor}
            />
            <section className={classes.top}>
               <Caption
                  item={{
                     title: item.title,
                     subTitle: item.subTitle,
                     reverseColor: item.reverseColor,
                  }}
                  isGuideDetailPage={true}
               />
            </section>
            <div
               className={classes.desc}
               style={
                  isEventPage
                     ? {
                          paddingBottom: 0,
                       }
                     : {}
               }
            >
               {item.desc}
            </div>
            {!!item.footer && (
               <div className={`${classes.desc} footer`}>{item.footer}</div>
            )}
            <GotoTop
               isScroll={isScrolling}
               goTo={goToTop}
               endScroll={endScroll}
               bottomButtonSize={bottomButtonSize}
            />
         </div>
      </>
   );
};

export default GuideDetailPage;
